import React from 'react';
import './StudentCampaignSection.css';
// import { FaFilePdf } from 'react-icons/fa';

const StudentCampaignSection = () => {
	const targetDate = new Date('2025-06-20');
	const today = new Date();

	// 残り日数を計算
	const remainingDays = Math.ceil((targetDate - today) / (1000 * 60 * 60 * 24));

	return (
		<div className="student-campaign-section">
			<h2 className="student-campaign-title">Campaign</h2>
			<p className="student-campaign-description">期間限定のキャンペーンです。</p>
			<div className="student-campaign-cards">
				<h3 className="student-campaign-text">
					学生プランキャンペーン
				</h3>
				<p className="student-campaign-list">
				<i className="fa-solid fa-circle"></i>2025年7月は、学生プランの入学時期となります。<br />
				<i className="fa-solid fa-circle"></i>2025年6月2日までに入学していただいた方は、<strong>コース費用が30%OFF</strong>になります。<br />
				<i className="fa-solid fa-circle"></i>2025年6月20日までに入学していただいた方は、<strong>コース費用が20%OFF</strong>になります。<br />
				<i className="fa-solid fa-circle"></i>通常の入学は、1年中いつでも可能です。
				</p>
				{/* 残り日数を表示 */}
				<p className="remaining-days">
					残りあと{remainingDays}日
				</p>

			</div>
		</div>
	);
};

export default StudentCampaignSection;